export const SET_USER = 'SET_USER'
export const SET_USER_PASSWORD_REQUIREMENTS = 'SET_USER_PASSWORD_REQUIREMENTS'
export const SET_USER_FALLBACK_OPTIONS = 'SET_USER_FALLBACK_OPTIONS'
export const RESET_USER = 'RESET_USER'
